<template>
	<div class="article_preview">
		<!-- 最大的缩小 -->
		<div class="over-hidden top-box">
			<!-- 最外层左边一栏 -->
			<div class="fl" style="width: 880px; min-height: 800px;">
				<div class="per-line-40">
					文章預覽
				</div>
				<div class="per-big-cell tl white-b pad-15" style="min-height: 800px;">
					<div v-html='article_detail' class="mar-bot-15"></div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>

export default {
	name: 'article_preview',
	data () {
		return {
			article_detail: '缺少內容參數',
		}
	},
	created () {
		this.article_detail = this.$route.query.article_detail
	},
	methods: {

	},
}
</script>

<style scoped>
.article_preview {
}
</style>


// WEBPACK FOOTER //
// src/components/article_preview.vue